import React from 'react'
import classNames from 'classnames'

const SettingRadioInput = ({
  className,
  value,
  checked,
  disabled,
  children,
  onChange
}) =>
  <label className={classNames('radio', className, { selected: checked })}>
    <input
      type="radio"
      name="settingGroup"
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
    {children}
  </label>

export default SettingRadioInput
